module.exports = __webpack_public_path__ + "img/product_info.75c2ff2f.jpg";